@if (score) {
  <div
    class="nutriscore"
  [ngStyle]="{
    'background-image':
      'url(/assets/imgs/nutriscore/nutriscore-' + score.toLowerCase() + '.png)'
  }"
  ></div>
}
